import { render, staticRenderFns } from "./DriverLicense.vue?vue&type=template&id=d5b601cc&scoped=true&"
import script from "./DriverLicense.vue?vue&type=script&lang=js&"
export * from "./DriverLicense.vue?vue&type=script&lang=js&"
import style0 from "./DriverLicense.vue?vue&type=style&index=0&id=d5b601cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b601cc",
  null
  
)

export default component.exports